<template>
  <div id="system-health-dashboard">
    <SystemWithActiveAlert />
    <SystemHealthRating />
  </div>
</template>

<script>
import SystemHealthRating from '@shared/components/systemHealth/SystemHealthRating.vue';
import SystemWithActiveAlert from '@shared/components/systemHealth/SystemWithActiveAlert.vue';

export default {
  name: 'SystemHealthDashboard',
  components: {
    SystemHealthRating,
    SystemWithActiveAlert,
  },
};
</script>

<style lang="scss">

#system-health-dashboard {
  display: flex;
  align-items: center;
  height: 100%;
  @media (max-width: 1400px) {
    font-size: 90%;
  }
  @media (min-width: 1700px) {
    font-size: 110%;
  }
  .card-container {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 150px;
    width: 300px;
    background-color: $N100;
    margin-right: 20px;
    border-radius: 4px;
    padding: 8px 12px;
    .c-header-container {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .c-header {
        color: $N20;
        font-size: 0.825rem;
        font-weight: 600;
      }
      .c-date-container {
        display: flex;
        flex-direction: column;
        position: relative;
        .c-date {
          font-size: 0.875rem;
          color: #F3F4F6;
        }
      }
    }
    .c-number-container {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      flex: 1;
      .c-number {
        font-size: 8em;
        line-height: 1em;
        color: #FFFFFF;
      }
    }
    .c-graph-container {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 90%;
      .c-graph {
        display: flex;
        align-items: center;
        width: 100%;
        height: 100%;
        .c-chart-container {
          width: 80%;
          height: 100%;
          .c-chart {
            height: 100%;
          }
        }
      }
      .c-legend-container {
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        .c-legend {
          display: flex;
          align-items: center;
          .c-legend-green {
            background-color: #4CD87D;
            width: 20px;
            height: 8px;
            border-radius: 4px;
            border: 1px solid #FFFFFF;
          }
          .c-legend-yellow {
            background-color: #FFAB00;
            width: 20px;
            height: 8px;
            border-radius: 4px;
            border: 1px solid #FFFFFF;
          }
          .c-legend-red {
            background-color: #F7433A;
            width: 20px;
            height: 8px;
            border-radius: 4px;
            border: 1px solid #FFFFFF;
          }
          .c-legend-label {
            font-size: 0.75em;
            color: $WHITE;
            margin-left: 8px;
            width: 50px;
          }
        }
      }
    }
  }
}
</style>
